import * as types from './mutation-types'

export const loadCollaboratorActivities = ({ commit}, params ) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/project/activities/logs', {params}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const loadCollaboratorProjects = ({ commit}, params ) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/user/worked/project', {params}).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const downloadUserActivitiesLog = ({ commit, dispatch, state }, params) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`download/user/project/activities/logs`, { responseType: 'blob', params }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


